<template>
  <Container type="card-full">
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">单位类型</div>
          <div class="field">
            <el-select v-model="query.comtype" :clearable="true" placeholder="请选择">
              <el-option v-for="item in roles" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">单位名称</div>
          <div class="field">
            <el-input v-model.trim="query.comcodename" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">联系电话</div>
          <div class="field">
            <el-input v-model.trim="query.commobile" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type='primary' @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid :list="list" tableheight="700" flexname="" :cols="cols" :showfooter="false" :showPage="true" :resizable="true"
      :total="query.total" :needBlackRow="false" :needPopMenu="false" :canbeEdit="false" @cellClick="cellClick"
      @cellDblClick="viewProject" @pagechange="pagechange" :isOperate="btn.isOperate" :operateBtn="btn.right"
      @vggridClick="vggridClick">
      <template slot="btn">
        <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
      </template>
    </vggrid>
  </Container>
</template>
<script>
import request from '@/utils/request'
import MenuBtn from "../common/menuBtn"
import vggrid from '../common/vggrid'
import utils from '../../assets/js/utils'
export default {
  name: 'comIndex',
  data() {
    return {
      menuid: this.$route.query.menuid,
      btn: {},
      list: [],
      cols: [
        { type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 80 },
        { field: 'comtypename', fieldtype: 'C', title: '单位类型', calculExpr: '', addNewRowFlg: false },
        { field: 'comfullname', fieldtype: 'C', title: '单位名称', calculExpr: '', addNewRowFlg: false },
        { field: 'comcontact', fieldtype: 'C', title: '联系人', calculExpr: '', addNewRowFlg: false },
        { field: 'commobile', fieldtype: 'C', title: '联系电话', calculExpr: '', addNewRowFlg: false },
        { field: 'comregtime', fieldtype: 'T', title: '注册日期', calculExpr: '', addNewRowFlg: false, formatter: ['toDateString', ''] },
        { field: 'cositemapsynergywaydesc', fieldtype: 'C', title: '与代理协同方式', calculExpr: '', addNewRowFlg: false },
        { field: 'cositemcomstatusdesc', fieldtype: 'C', title: '审核状态', calculExpr: '', addNewRowFlg: false }
      ],
      comform: false,
      com: {},
      query: {
        total: 0,
        limit: 20,
        offset: 0,
        comtype: '',
        comcodename: ''
      },
      roles: []
    }
  },
  created() {
    this.$on('ADD', () => this.addCom())
    this.$on('CHG', () => this.chgCom())
    this.$on('DEL', () => this.delCom())
    this.$on('SETCOMTYPE', () => this.setComtypes())
    this.$on('USER', () => this.addUser())
    this.$on('CLOSE', () => this.close())
  },
  activated() {
    // this.init()
    this.getSysCodeList()
    this.getPageList()
  },
  mounted() {
  },
  watch: {
    async '$route'() {
      this.getPageList()
    }
  },
  components: { MenuBtn, vggrid },
  methods: {
    init() {
      this.query = {
        total: 0,
        limit: 20,
        offset: 0,
        comtype: ''
      }
    },
    async getSysCodeList() {
      let res = await request({
        method: 'get',
        url: '/kfgl/syscode/getSysCodeList',
        params: { syscode: 'cositemcomtype' }
      })
      this.roles = res
    },
    btnClick(code) {
      this.$emit(code)
    },
    vggridClick(code, row) {
      this.com = row
      this.$emit(code, row)
    },
    btnmenuclick(btn) {
      this.btn = btn
    },
    async close() {
      this.$store.commit('close_tab', { routeName: this.$route.name, vm: this, newRouteName: '' })
    },
    async addCom() {
      let form = {
        comid: 0,
        comfromflg: '3'
      }
      this.$router.push({ name: 'comForm', params: { form: form, type: 1 } })
    },
    async chgCom() {
      // this.com = row
      if (!this.com.comid) {
        this.$message.warning('请选择一个单位!')
        return
      }
      this.$router.push({ name: 'comForm', params: { form: this.com, type: 2 } })
    },
    async addUser() {
      let form = {
        comid: this.com.comid
      }
      this.$router.push({ name: 'comuserIndex', params: { form: form } })
    },
    async authMenu() {
      if (!this.com.comid) {
        this.$message.warning('请选择一个单位!')
        return
      }
      this.$router.push({ name: 'comMenuForm', params: { form: this.com } })
    },
    async setComtypes() {
      if (!this.com.comid) {
        this.$message.warning('请选择一个单位!')
        return
      }
      this.$router.push({ name: 'comTypeForm', params: { form: this.com } })
    },
    async delCom() {
      if (!this.com.comid) {
        this.$message.warning('请选择一个单位!')
        return
      }
      this.com.cosid = this.$store.getters.loginUser.cosid
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let data = await request({
          url: '/ywgl/com/delCom',
          method: "post",
          data: this.com
        })
        if (data.issuccess === 2) {
          this.$message.warning('该单位存在多个用户，不可删除！')
          return
        }

        if (data.issuccess === 1) {
          this.getPageList()
          this.$message.success('删除成功！')
        }
      })
    },
    async save() {
      await request({
        url: '/ywgl/com/addOrEdit',
        method: "post",
        data: this.com
      })
      this.$message.success('操作成功')
      this.comform = false
      if (!this.com.comid) {
        this.query.currPage = 1
      }
      await this.getPageList()
    },
    async cellClick(row) {
      this.com = row.row
    },
    async viewProject(row) {
      this.com = row.row
      this.$router.push({ name: 'comView', params: { comid: this.com.comid, innerbtn: this.btn.inner } })
    },
    async pagechange(page) {
      this.query.offset = page.pageSize * (page.currentPage - 1)
      this.query.limit = page.pageSize
      this.getPageList()
    },
    search() {
      this.query.offset = 0
      this.getPageList()
    },
    async getPageList() {
      this.loading = true
      this.query.isWarehousing = true
      let res = await request({
        method: 'get',
        url: '/ywgl/com/getPageList',
        params: this.query
      })
      this.list = res.list
      this.query.total = res.count[0].count
      this.loading = false
    }
  },
  filters: {
  }
}
</script>
<style lang="scss">
</style>
